import { useEffect, useState, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Link, useSearchParams } from 'react-router-dom';
// import auth from '../../api/auth';
// Components
import auth from '../../api/auth'
import { TextInput } from 'carbon-components-react';
import Button from '../../components/Button/Button';
import { getSSOURL } from '../../api/auth-api';
import { toaster } from '../../helpers/toaster';
const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false)
  const {client} = useParams()
  const [searchParams] = useSearchParams()
  const [ssoUrls, setSsoUrls] = useState([])
  const saml = useMemo(() => {
    return searchParams.get("saml")
  }, [searchParams])

  useEffect(() => {
    if (saml === "true") {
      auth.checkToken((isAuthenticated, usertype) => {
        if (isAuthenticated) {
          props.setAuth(true);
          // setUsertype(usertype);
        }
        else {
          props.setAuth(false);
          // setUsertype(null);
        }
      })
      // props.setAuth(true)
      // props.setUsertype(currUser.usertype)
      // const token = getCookie("Token")
      // setTokens()
      // const access = getCookie("access")
      // const refresh = getCookie("refresh")
      // setTokens({ access, refresh })
      // history()
      // navigateToNextUrl({ isSso: true })
      // if (access && refresh && isExpired(access) === false && isExpired(refresh) === false) {
      //   navigateToNextUrl({ isSso: true })
      // }
    } 
    // else {
    //   const isAuth = isUserAuthenticated()
    //   if (pathname.includes("login") && isAuth) {
    //     navigateToNextUrl()
    //   }
    // }
    // setIsPageLoading(false)
  }, [saml])

  useEffect(() => {
    if (props.isAuth) {
      history(`/${client}`)
    }

  }, [])

  useEffect(() => {
    getSSOURL().then(res => {
      setSsoUrls(res)
    })
  }, [])

  // Handle SSO error messages from URL parameters
  useEffect(() => {
    const error = searchParams.get('error');
    
    if (error === 'user_not_found') {
      toaster('User not found. Please contact your administrator to create your account.', 'error');
      // Clear the error from URL
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    } else if (error === 'auth_failed') {
      toaster('Authentication failed. Please try again.', 'error');
      // Clear the error from URL
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }, [searchParams]);

  const onLogin = () => {
    let credentials = { email, password }
    setIsProcessing(true)
    auth.login(credentials, () => {
      props.setAuth(true)
      let path = `/${client}`
      localStorage.setItem('client', client)

      history(path)
      setIsProcessing(false)
    }, () => {
      setIsProcessing(false)
    })
  }

  const onKeyEnter = (e) => {
    if(e.keyCode === 13) {
      onLogin()
    }
  }

  return (
    <Container>
      <InputContainer onKeyDown={onKeyEnter}>

      { (ssoUrls && ssoUrls.length > 0 ) &&
      <div className="pb-3">
      {ssoUrls.map((element) => {
        return(
          <a
          href={element?.url}
        >
                <Button
            style={{ width: "100%", marginTop:10 }}
            >
            {element?.button_text}
          </Button>
        </a>
        )
      })}

      </div>

      }
        <i
          style={{ fontSize: 70, marginBottom: 16, color: "#d4d4d4" }}
          className="fal fa-user-circle"/>
        <PrimaryText>Sign in to your account</PrimaryText>
        <SecondaryText>Enter your credential below</SecondaryText>
        <TextInputContainer>
          <TextInput
            id="login-email"
            labelText="Email"
            // placeholder="Enter Email"
            onChange={e => setEmail(e.target.value)}
            />
          </TextInputContainer>
        <TextInputContainer>
          <TextInput.PasswordInput
            id="login-password"
            labelText="Password"
            // placeholder="Enter Password"
            onChange={e => setPassword(e.target.value)}
            />
        </TextInputContainer>
        <Button
          style={{ width: "100%", marginTop:10 }}
          onClick={onLogin} disabled={isProcessing}>
          Sign in
          <i
            style={{ marginLeft: 8, marginTop: 3 }}
            className="fal fa-arrow-circle-right"/>
        </Button>
        <ForgotPasswordContainer>
          <Link to={`/${client}/forgot-password`}>Forgot Password</Link>
        </ForgotPasswordContainer>
      </InputContainer>
      <SecondaryText>{new Date().getFullYear()} &copy; Xogene Services LLC</SecondaryText>
    </Container>
  );
};


export default Login;

export const Container = styled.div`
  padding: 20px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const InputContainer = styled.div`
  width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  padding: 30px;
  margin-top: 50px;
`

export const TextInputContainer = styled.div`
  width: 100%;
  margin-bottom: 12px;
`

export const PrimaryText = styled.div`
  font-size: 17px;
  text-align: center;
  margin-bottom: 6px;
`

export const SecondaryText = styled.div`
  font-weight: 400;
  line-height: 1;
  color: #999;
  text-align: center;
  margin-bottom: 16px;
`

const ForgotPasswordContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`
